import React,{ Fragment, PureComponent, } from 'react';
import {Modal,Spin} from 'antd';
import PropTypes from 'prop-types';
import FormFormat from '@/components/FormFormat/FormFormat';
import Lang from "@/components/Lang/Lang";

/**
 * 表格弹窗组件 回调Form数据
 * @author FJJ
 * @version 1.0
 * @copyright 2021-2021, all rights reserved. Essa.cn
 *
 * 必要传参
 * showModal 是否显示 对话窗口
 * handleCancel 关闭弹窗
 * options 选项内容：具体查看FormFormat组件配置 [{
                     * name:'返回的Key', 读取数据值
                     * title:'显示的文本',
                     * required: 是否必填，默认false
                     * disabled:true不可编辑,
                     * hidden:true 隐藏,
                     * type 默认普通Input ,
                                 * Number：数字类型,
                                 * Date：时间组件 ,
                                 * UploadImage:
                                 * DateRangePicker: 时间选择范围类型,
                                 * PicView: 图片显示
                                 * UploadFile:
                 * }]
 * 可选 参数
 * title {
     * cnTitle 国际化显示文字，默认值，优选
     * cnTitleID 国际化KEY值，
 * }
 * initialValues 默认值obj
 * saveFormValue 回调Form数据  // 或调ref 此方法 handleGetFormValue
 * footer 配置是否有底部
 * width 配置宽度
 * loading 配置loading状态
 * formItemLayout 表单行格式
 * top 配置表单头内容
 **/
class ModalFormComponent extends PureComponent {
    static propTypes = {
        showModal: PropTypes.bool.isRequired,
        options: PropTypes.array.isRequired,
        handleCancel: PropTypes.func.isRequired,
        initialValues: PropTypes.object,
        saveFormValue: PropTypes.func,
        enumClass: PropTypes.string,
        searchClass: PropTypes.object,
        footer: PropTypes.string,
        width: PropTypes.number,
        loading: PropTypes.bool,
        formItemLayout: PropTypes.object,
        okText:PropTypes.string,
        cancelText:PropTypes.string,
    }
    static defaultProps = {
        showModal: false,
        options:[],
        initialValues:{},
        loading: false,
        width: 600,
        footer: '',
        formItemLayout:{},
        okText:'',
        cancelText:'',
    };
    constructor(props){
        super(props)
        this.state={
            fileList: [],
        }
    };
    /**
     * 点击确认时 获取表单数据
     ***/
    async handleOK(){
        const res = await this.onRefFormFormat.handleOK();
        if(res&&res.success){
            const values = res.data;
           if(this.props.saveFormValue)this.props.saveFormValue(values);
        }
        return
    }
    async handleGetFormValue(){
        return await this.onRefFormFormat.handleOK();
    }
    // 关闭操作
    handleCancel = () => this.props.handleCancel();
    onRefForm = (ref) =>  this.onRefFormFormat = ref;
    /***
     * 清除表单 字段值 | 设置字段)
     */
    setField (field,value){
        this.onRefFormFormat.setField(field,value)
    }
    componentDidMount() {
      if( this.props.onRef)  this.props.onRef(this);
    };
    render() {
        const { showModal, options, title, footer, width,loading,initialValues,formItemLayout,okText,cancelText,} = this.props;
        const flagFooter = footer==null;
        const langTitle = title?(title.cnTitleId?<Lang id={title.cnTitleId}>{title.cnTitle}</Lang>:<Lang id={'CaoZuo'}>操作</Lang>):null;
        return (<Fragment>
            {showModal&&(flagFooter? <Modal
                open={showModal}
                title= {langTitle}
                onOk={(dat)=>this.handleOK(dat)}
                onCancel={()=>this.handleCancel()}
                labelAlign = 'left'
                footer={footer}
                okText={okText||Lang({id:'queren',default:'确认'})}
                cancelText={cancelText||Lang({id:'QuXiao',default:'取消'})}
                width={width}>
                <Spin tip='loading' spinning={loading}>
                    <>
                    {this.props.top}
                    <FormFormat onRef={this.onRefForm}
                                formItemLayout={formItemLayout}
                                formLayout="horizontal"
                                options={options}
                                initialValues={initialValues}
                    />
                    {this.props.children}
                    </>
                </Spin>
            </Modal>:<Modal
                open={showModal}
                title= {langTitle}
                onOk={this.handleOK.bind(this)}
                onCancel={this.handleCancel.bind(this)}
                labelAlign = 'left'
                width={width}
                okText={okText||Lang({id:'queren',default:'确认'})}
                cancelText={cancelText||Lang({id:'QuXiao',default:'取消'})}
            >
                <Spin tip='loading' spinning={loading}>
                    {this.props.top}
                    <FormFormat onRef={this.onRefForm}
                                options={options}
                                formLayout="horizontal"
                                formItemLayout={formItemLayout}
                                // formItemLayout={formItemLayout}
                                initialValues={initialValues}
                    />
                    {this.props.children}
                </Spin>
            </Modal>)}
        </Fragment>);
    }
}
export default ModalFormComponent;
